import * as React from 'react';
import { Combobox, Field, makeStyles } from '@fluentui/react-components';

type FieldProps = Pick<
  React.ComponentProps<typeof Field>,
  'required' | 'hint' | 'label' | 'validationMessage' | 'validationState'
>;

type Props = React.ComponentProps<typeof Combobox> & FieldProps;

export function MultiSelectField({
  selectedOptions,
  defaultSelectedOptions,
  hint,
  label,
  validationMessage,
  validationState,
  value,
  required,
  ...props
}: Props) {
  const listboxRef = React.useRef<HTMLDivElement>(null);
  const classes = useStyles();

  const [input, setInput] = React.useState('');

  // @ts-ignore Fluent doesn't export types and function composition makes finding this type messy
  function onOptionSelect(event, data) {
    setInput(data.optionText ?? '');
    return props.onOptionSelect?.(event, data);
  }

  React.useEffect(() => {
    setInput(value as string);
  }, [selectedOptions]);

  return (
    <Field
      required={required}
      hint={hint}
      label={label}
      validationMessage={validationMessage}
      validationState={validationState}
    >
      <Combobox
        multiselect
        {...props}
        className={classes.field}
        selectedOptions={selectedOptions}
        defaultSelectedOptions={defaultSelectedOptions}
        listbox={{ className: classes.listbox, ref: listboxRef }}
        value={input}
        onFocus={() => setInput('')}
        onBlur={() => setInput(value as string)}
        onInput={(ev) => setInput((ev.target as HTMLInputElement).value)}
        onOptionSelect={onOptionSelect}
      />
    </Field>
  );
}

const useStyles = makeStyles({
  field: {
    '> div': {
      width: '100%',
    },
  },
  listbox: {
    // HACK! Fluent should figure out the max height for us, but they were lazy about it
    maxHeight: '480px',
  },
});
